/**
 * @solidus - BaseCalculoReducao
 */

export function calculaReducaoBaseCalculo(
  valor: number,
  reducao: number,
): number {
  const baseCalculo =
    parseFloat(valor.toFixed(2)) -
    parseFloat(valor.toFixed(2)) * (reducao / 100);
  return parseFloat(baseCalculo.toFixed(2));
}
